<div class="flex h-7 items-center justify-between mb-5">
  <div class="text-[1.125rem] leading-7 font-bold text-font-primary">Edit Restrictions</div>
  <button
    appRemoveFocus
    class="p-2 text-2xl text-secondary rounded-full transition-colors hover:bg-gray-100"
    title="Close"
    (click)="activeModal.close()"
  >
    <rkt-icon name="times" />
  </button>
</div>

<div class="text-font-primary flex flex-col gap-5">
  @for (restriction of restrictions; track $index) {
    <div>
      <div class="flex gap-2 text-[0.8125rem] leading-[1.125rem] mb-1">
        <app-details-item label="Solution" [value]="restriction.solution" />
        <app-details-item label="Transaction Type" [value]="restriction.transactionType" />

        <app-restriction-edit-item-field
          [restriction]="restriction"
          (changed)="onRestrictionChange($event, $index)"
          (errored)="onRestrictionError($event)"
        />
      </div>
    </div>
  }
</div>

@if (formError) {
  <div class="details-page-edit-form-error mt-5">{{ formError }}</div>
}

<div class="buttons">
  <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
  <button rktButton type="submit" [disabled]="hasError" (click)="onSave()">Save</button>
</div>
